<ion-header class="coupon-card-modal__header">
  <shared-close (tap)="dismiss(null)"></shared-close>
</ion-header>
<ion-content padding>
  <shared-v1-coupon-card [ticketSelected]="ticketSelected" [isCouponLocked]="!ticketSelected?.unlocked"
    [showRegisterButton]="!user?.getUser()?.isRegistered && showRegisterButton"
    [isCouponRegisterMandatory]="registerMandatory" (redeemEvent)="dismiss($event)"></shared-v1-coupon-card>
</ion-content>